import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAuth } from '@/context/AuthContext';
import { toast } from 'sonner';
import { Sparkles, ArrowLeft } from 'lucide-react';

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: '', email: '', password: '', role: 'owner' });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await register(form);
      toast.success('Cuenta creada');
      navigate(u.role === 'assistant' ? '/select-account' : '/onboarding');
    } catch (err) { toast.error(err?.response?.data?.detail || 'Error al registrar'); }
    setBusy(false);
  };

  return (
    <div className="min-h-screen grid place-items-center pp-grad-hero px-4" style={{ background: '#07090A' }}>
      <div className="dark w-full max-w-md">
        <button onClick={() => navigate('/')} className="flex items-center gap-2 text-sm text-[#A6C3B4] mb-6 hover:text-[#3EB489]"><ArrowLeft size={16} /> Volver</button>
        <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} className="pp-glass p-8">
          <div className="flex items-center gap-2 mb-6">
            <div className="w-10 h-10 rounded-2xl grid place-items-center pp-glow-mint" style={{ background: 'rgba(62,180,137,0.15)' }}><Sparkles className="pp-mint" size={20} /></div>
            <span className="text-xl font-bold text-white">PlannerPRO</span>
          </div>
          <h1 className="text-2xl font-bold text-white mb-6">Crea tu cuenta</h1>
          <form onSubmit={submit} className="space-y-4">
            <input data-testid="register-name" required value={form.name} onChange={set('name')} placeholder="Nombre completo" className="w-full h-12 px-4 rounded-xl bg-[rgba(255,255,255,0.05)] border border-[rgba(168,230,206,0.16)] text-white outline-none focus:border-[#3EB489]" />
            <input data-testid="register-email" required type="email" value={form.email} onChange={set('email')} placeholder="Email" className="w-full h-12 px-4 rounded-xl bg-[rgba(255,255,255,0.05)] border border-[rgba(168,230,206,0.16)] text-white outline-none focus:border-[#3EB489]" />
            <input data-testid="register-password" required type="password" value={form.password} onChange={set('password')} placeholder="Contraseña (mín 6)" className="w-full h-12 px-4 rounded-xl bg-[rgba(255,255,255,0.05)] border border-[rgba(168,230,206,0.16)] text-white outline-none focus:border-[#3EB489]" />
            <div className="grid grid-cols-2 gap-3">
              {[['owner', 'Titular'], ['assistant', 'Asistente']].map(([v, l]) => (
                <button type="button" key={v} data-testid={`register-role-${v}`} onClick={() => setForm({ ...form, role: v })} className={`h-11 rounded-xl border text-sm ${form.role === v ? 'pp-mint pp-glow-mint border-[#3EB489]' : 'text-[#A6C3B4] border-[rgba(168,230,206,0.16)]'}`}>{l}</button>
              ))}
            </div>
            <button data-testid="register-submit" disabled={busy} className="w-full h-12 rounded-xl font-semibold text-[#07090A] active:scale-[0.98]" style={{ background: '#3EB489' }}>{busy ? 'Creando...' : 'Crear cuenta'}</button>
          </form>
          <p className="text-sm text-[#A6C3B4] mt-6 text-center">¿Ya tienes cuenta? <button onClick={() => navigate('/login')} className="pp-mint font-medium">Inicia sesión</button></p>
        </motion.div>
      </div>
    </div>
  );
}
